/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Name_LabelInputs */

const en_audio_description_export_preset_name_label = /** @type {(inputs: Audio_Description_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset Name`)
};

const fr_audio_description_export_preset_name_label = /** @type {(inputs: Audio_Description_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du préréglage`)
};

const de_audio_description_export_preset_name_label = /** @type {(inputs: Audio_Description_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreingestellter Name`)
};

const it_audio_description_export_preset_name_label = /** @type {(inputs: Audio_Description_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome predefinito`)
};

const ru_audio_description_export_preset_name_label = /** @type {(inputs: Audio_Description_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название предустановки`)
};

const es_audio_description_export_preset_name_label = /** @type {(inputs: Audio_Description_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del preajuste`)
};

const zh_cn2_audio_description_export_preset_name_label = /** @type {(inputs: Audio_Description_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设名称`)
};

const ja_audio_description_export_preset_name_label = /** @type {(inputs: Audio_Description_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセット名`)
};

const hi_audio_description_export_preset_name_label = /** @type {(inputs: Audio_Description_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट नाम`)
};

const pt_pt2_audio_description_export_preset_name_label = /** @type {(inputs: Audio_Description_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome predefinido`)
};

/**
* | output |
* | --- |
* | "Preset Name" |
*
* @param {Audio_Description_Export_Preset_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_name_label = /** @type {((inputs?: Audio_Description_Export_Preset_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_name_label(inputs)
	if (locale === "de") return de_audio_description_export_preset_name_label(inputs)
	if (locale === "it") return it_audio_description_export_preset_name_label(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_name_label(inputs)
	if (locale === "es") return es_audio_description_export_preset_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_name_label(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_name_label(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_name_label(inputs)
	return en_audio_description_export_preset_name_label(inputs)
});